const optionSerializer = element => {
  return {
    value: element.id,
    label: element.title
  }
}

export default optionSerializer;